<div class="eventq-user-bar">
  <button type="button" class="eventq-user-bar__logout" aria-label="Log out" (click)="logout.emit()">
    <mat-icon>logout</mat-icon>
  </button>
  <span class="eventq-user-bar__email">{{ email() }}</span>
</div>
